import { Modal } from 'antd'

const ANTDModal = ({ ...props }) => {
  return <Modal {...props} />
}

export default ANTDModal
